
<template lang="pug">
  div.eui-callout(:class="classname", v-if="open", @click="handleClick")
    Button.eui-callout_close
      CloseIcon
    span.eui-callout_text
      slot
</template>


<script>
import Button from '../Button/Button.vue';
import CloseIcon from '../../assets/icon-cross.svg';


export default {
  name: 'euiCallout',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'error'
    },
  },
  methods: {
    handleClick() {
      this.$emit('handleClick');
    }
  },
  components: { Button, CloseIcon },
  computed: {
    classname() {
      return `eui-callout_theme_${ this.variant }`;
    }
  }
};

</script>

<style lang="scss">
.eui-callout {
  position: relative;
  background: #fefefe;
  border: 1px solid;
  padding: var(--theme-spacing);
  color: #000;
  white-space: no-wrap;
  display: inline-flex;

  &_close {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    cursor: pointer;

    width: 22px;
    height: 22px;
    border: 1px solid currentColor;
    padding: 0;

    color: #777;
    background: #fff;
    justify-content: center;
    .eui-button_icon {
      margin: 0;
      --icon-size: 14px;
    }

    &:hover {
      color: #333;
    }

  }

  &_theme_error {
    color: #dd0000;
    border-color: currentColor;
  }
}
</style>
